import request from '@/utils/request'

/**
 * 获取设备类型列表
 */

export const getEquipTypeOptionLists = () => {
    return request({
        url: '/equipType/option/lists'
    })
}
/**
 * 导出设备类型列表
 */
export const getExportEquipTypeOptionLists = (data) => {
    return request({
        url: '/equipType/lists',
        params: data
    })
}

// 设备类型-删除
export const delEquipType = (id) => {
    return request({
        url: `/equipType/${id}`,
        method: 'DELETE'
    })
}

// 设备类型-添加
export const addEquipType = (data) => {
    return request({
        url: '/equipType/manage',
        method: 'POST',
        data
    })
}

// 设备类型-详情
export const getEquipTypeDetail = (id) => {
    return request({
        url: `/equipType/${id}`
    })
}

// 设备类型-编辑
export const putEquipType = (data) => {
    return request({
        url: '/equipType/manage',
        method: 'PUT',
        data
    })
}
